import { render, staticRenderFns } from "./AccountInfoForm.vue?vue&type=template&id=515c66f3&scoped=true"
import script from "./AccountInfoForm.vue?vue&type=script&lang=js"
export * from "./AccountInfoForm.vue?vue&type=script&lang=js"
import style0 from "./AccountInfoForm.vue?vue&type=style&index=0&id=515c66f3&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c66f3",
  null
  
)

export default component.exports